module.exports = __webpack_public_path__ + "img/cases-brand-maxam-8.f0e225a0.jpg";